'use client'

import { useEffect } from 'react'

type BackButtonProps = {
  className?: string
  size?: 'default' | 'lg'
  href?: string
}

export default function BackButton({ className = '', size = 'default', href }: BackButtonProps) {
  // Next.js sets history.scrollRestoration = 'manual' during hydration.
  // Reset to 'auto' so the browser natively restores scroll position on history.back().
  useEffect(() => {
    window.history.scrollRestoration = 'auto'
  }, [])

  const iconSize = size === 'lg' ? 36 : 24
  const sharedClassName = `inline-flex items-center justify-center group cursor-pointer rounded-full ${size === 'lg' ? 'p-3' : 'p-2'} transition-colors hover:bg-white/10 ${className}`

  const handleClick = () => {
    const referrer = document.referrer
    const sameOrigin = referrer && new URL(referrer).origin === window.location.origin

    if (sameOrigin) {
      window.history.back()
    } else if (href) {
      window.location.href = href
    } else {
      window.history.back()
    }
  }

  const icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={iconSize}
      height={iconSize}
      viewBox="0 -960 960 960"
      fill="currentColor"
      className="text-white drop-shadow-md"
    >
      <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
    </svg>
  )

  return (
    <button onClick={handleClick} className={sharedClassName} aria-label="Vissza">
      {icon}
    </button>
  )
}
